import type { ReactNode } from 'react'

import classes from './styles.module.scss'

type Props = {
  title: ReactNode
  amount: ReactNode
  transactionName: ReactNode
  transactionId: ReactNode
  date: string
  status: ReactNode
}

export default function TransactionItem({ title, amount, transactionName, transactionId, date, status }: Props) {
  return (
    <section className={classes.root} data-testid='transaction-item'>
      <div className={classes.left}>
        {Boolean(title) && (
          <h4 className={classes.title} data-testid='transaction-item-title'>
            {title}
          </h4>
        )}

        <div className={classes.body}>
          {Boolean(transactionId) && <div data-testid='transaction-item-id'>{transactionId}</div>}
          {Boolean(transactionName) && <div data-testid='transaction-item-instrument'>{transactionName}</div>}
          {Boolean(date) && <div data-testid='transaction-item-date'>{date}</div>}
        </div>
      </div>

      <div className={classes.right}>
        {Boolean(amount) && (
          <b className={classes.amount} data-testid='transaction-item-price'>
            {amount}
          </b>
        )}
        {Boolean(status) && status}
      </div>
    </section>
  )
}
